import getSavedCartList from './getSavedCartList';

async function getActiveSavedCart() {
  const savedCartList = await getSavedCartList();
  if(savedCartList.length >= 1){
    return savedCartList[0];
  }
  return null;
}

export default getActiveSavedCart;
